import { defineFcm } from '../shared/factory';

export const FCM_USE_MEMBERSHIP_DONATION_LANGUAGE = defineFcm('use_membership_donation_language')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'Payment forms',
		description: 'Whether or not to use copy that refers to transactions as membership',
		import: false,
	});
